import { GetCodeListResponse } from '../../../commons/kymw02/api-services/get-code-list.service';
import { GetMarkGroupListResponse } from '../kymw1500/api-services/get-mark-group-list.service';

/**
 * アイコンファイル適用期間指定画面の値を管理するクラス
 *
 * @export KYMW1510Model
 * @class KYMW1510Model
 */
export class KYMW1510Model {
  /** アイコンコード */
  public iconCode: string;
  /** アイコンコード連番 */
  public iconCodeBranch: string;
  /** アイコン名 */
  public iconName: string;
  /** アイコングループ */
  public iconGroup: string;
  /** アイコン区分 */
  public iconDiv: string;
  /** 配置区分 */
  public arrangeDiv: string;
  /** アイコン説明 */
  public iconExplain: string;
  /** 出力区分 */
  public outputDiv: string;

  /** アイコン区分リスト */
  public iconDivList: GetCodeListResponse = [];
  /** 配置区分リスト */
  public arrangeDivList: GetCodeListResponse = [];
  /** マークグループリスト */
  public markGroupList: GetMarkGroupListResponse = [];

  /** 使用開始 指定無し */
  public notDesignateStart = true;

  /** 使用開始 受注コード */
  public startOrderCode: string = <string>'';
  public startOrderCodeEnabled = false;

  /** 使用開始　配達企画回 */
  public startDelivCatalogIdDisabled = true;

  /** 使用終了 指定無し */
  public notDesignateEnd = true;

  /** 使用終了 受注コード */
  public endOrderCode: string = <string>'';
  public endOrderCodeEnabled = false;

  /** 使用終了　配達企画回 */
  public endDelivCatalogIdDisabled = true;

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   */
  public updateMarkGroupList(serverData: any) {
    this.markGroupList = serverData;
  }

  /**
   * CWSアイコン基本情報を更新する
   *
   * @param serverData CWSアイコン基本情報のサーバ取得データ
   */
  public updateCwsIconBaseData(serverData: any) {
    this.iconName = serverData.IconName;
    this.iconGroup = this.convertIconGroupCode(serverData.IconGroupCode);
    this.iconDiv = this.convertIconDiv(serverData.IconDiv);
    this.arrangeDiv = this.convertArrangeDiv(serverData.ArrangeDiv);
    this.iconExplain = serverData.IconExplain;
    this.outputDiv = this.convertOutputDiv(serverData.OutputDiv);
    this.startOrderCode = serverData.StartOrderCode;
    this.endOrderCode = serverData.EndOrderCode;
    this.notDesignateStart = this.startOrderCode === '0000000';
    this.notDesignateEnd = this.endOrderCode === '9999999';
    this.startOrderCodeEnabled = !this.notDesignateStart;
    this.endOrderCodeEnabled = !this.notDesignateEnd;
  }

  /**
   * グループのコード値を表示用の値に変換する
   *
   * @param iconGroupCode グループのコード値
   */
  private convertIconGroupCode(iconGroupCode: string): string {
    for (const group of this.markGroupList) {
      if (iconGroupCode === group.MarkGroupCode) {
        return group.Caption;
      }
    }
    return '';
  }

  /**
   * アイコン区分のコード値を表示用の値に変換する
   *
   * @param iconDiv アイコン区分のコード値
   */
  private convertIconDiv(iconDiv: string): string {
    for (const e of this.iconDivList) {
      if (iconDiv === e.CodeValue) {
        return e.CodeName
      }
    }
    return '';
  }

  /**
   * 配置区分のコード値を表示用の値に変換する
   *
   * @param arrangeDiv 配置区分のコード値
   */
  private convertArrangeDiv(arrangeDiv: string): string {
    for (const e of this.arrangeDivList) {
      if (arrangeDiv === e.CodeValue) {
        return e.CodeName
      }
    }
    return '';
  }

  /**
   * 出力区分の01010101といった形式の値をを表示用の値に変換する
   *
   * @param outputDiv 出力区分
   */
  private convertOutputDiv(outputDiv: string): string {
    // 出力区分
    // 右から1文字目：商品マスタ、2文字目：ウィークリー、3文字目：デイリー、
    // 4文字目：スポット、5文字目：見切り品、6文字目：注文確認画面表示対象フラグ、
    // 7文字目：予備、8文字目：予備
    // 0：表示しない、1：表示する
    // ※ 以下パラメータについては値として返却しているが、フロントエンド側での使用を想定していない
    // 4文字目：スポット
    // 7文字目：予備
    // 8文字目：予備
    const outputDivMap = {
      1: '商品マスタ',
      2: 'ウィークリー',
      3: 'デイリー',
      4: '',
      5: '見切り品',
      6: '注文確認画面表示対象フラグ',
      7: '',
      8: '',
    }

    let resultList: string[] = [];
    const outputDivList = outputDiv.split('');
    outputDivList.reverse();
    for (var i = 0; i < outputDivList.length; i++){
      if (outputDivList[i] === '1') {
        if (outputDivMap[i+1] !== '') {
          resultList.push(outputDivMap[i+1]);
        }
      }
    }
    return resultList.join(', ');
  }
}
